






























import { getHumanReadableFileSize } from '@wra/file';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { DateLabel, toNativeDateTime, toShortDate } from '@/common/datetime';
import { ReportFile } from '@/models/report.model';
import { ReportStore } from '@/store/report';

@Component({
  components: {
    DateLabel,
  },
})
export default class ReportPageListItemFile extends Vue {

  @Prop() file!: ReportFile;

  @ReportStore.Bind.Action download!: ReportStore.Action<'download'>;

  error = null;
  isDownloading = false;

  get iconSrc() {
    switch (this.file.type) {
    case 'pdf':
      return 'img/icons8-pdf-48.png';
    default:
      return 'img/icons8-document-48.png';
    }
  }

  get fileSize() {
    return getHumanReadableFileSize(this.file.size);
  }

  get lastModifiedDate() {
    const date = toNativeDateTime(this.file.lastModified);
    return date
      ? toShortDate(date)
      : '-';
  }

  attemptDownload() {
    try {
      this.isDownloading = true;
      this.download(this.file);
    }
    catch (error) {
      this.error = error;
    }
    finally {
      this.isDownloading = false;
    }
  }

}
